import { Inject, Injectable } from '@angular/core';
import { AuthService, EnvironmentService, HttpRequestService, LogService, NotificationService, UtilService } from 'src/app/shared';
import { ServiceApiService } from 'src/app/shared/api/service-api.service';

@Injectable({
  providedIn: 'root',
})
export class CommunicationApiService extends ServiceApiService {
  constructor(
    @Inject(AuthService) authService: AuthService,
    @Inject(UtilService) utilService: UtilService,
    @Inject(LogService) logService: LogService,
    @Inject(HttpRequestService) httpRequestService: HttpRequestService,
    @Inject(EnvironmentService) environmentService: EnvironmentService,
    @Inject(NotificationService) notificationService: NotificationService
  ) {
    super(authService, utilService, logService, httpRequestService, environmentService, notificationService, 'communication');
  }
}
